/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { responsiveStyles, singleSectionStyles } from "../../commons/styles";
import { FAQ, FAQCategoryEnum } from "../../components/FAQ";
import { routeURL } from "../../constants/commons";
import backIcon from "../../assets/back-arrow.svg";
import { useIsMobile } from "../../hooks/useIsMobile";

export const FAQPage: React.FunctionComponent = () => {
  const history = useHistory();
  // Function which is called when the back button in the registration screen is clicked
  const redirectToLandingPage = () => {
    history.push(routeURL.landingPage);
  };

  const isMobileView = useIsMobile();

  return (
    <React.Fragment>
      <div className="single-section" css={singleSectionStyles()}>
        <div css={responsiveStyles}>
          <button
            onClick={redirectToLandingPage}
            className="border-0 user-button-style bg-none p-0 back-button-margin"
          >
            <div
              className={`d-flex align-items-center p-0 ${
                isMobileView ? "mb-3" : "mb-4"
              }`}
            >
              <img src={backIcon} alt="" className="back-button" />
              <div className="ml-2 back-button-style">BACK</div>
            </div>
          </button>
        </div>
        <FAQ
          categories={[
            FAQCategoryEnum.JOINING_PARTNER_FIT,
            FAQCategoryEnum.SCHEDULING_CUSTOMER_SESSIONS,
            FAQCategoryEnum.PAYMENTS,
          ]}
        />
      </div>
    </React.Fragment>
  );
};
